import { api, ApiError } from './api-client';

import type { WaitlistEntryWire } from './api-client';

/**
 * Definição ÚNICA da query de fila de espera por pessoa.
 *
 * Dois consumidores compartilham a MESMA queryKey (`['person-waitlist', id]`):
 * o painel da Conversa em curso (`use-panel-fixtures.usePersonWaitlist`) e a
 * ficha da pessoa (`use-persons.usePersonWaitlist`). Quando cada um tinha a sua
 * queryFn, os shapes divergiram (envelope × array) e a navegação SPA
 * conversa → ficha derrubava a página inteira («data.filter is not a
 * function» — medido ao vivo 12/Ago/2026). Um caminho só elimina a classe do
 * erro: quem precisar da query importa daqui; NUNCA redeclarar a key.
 *
 * 403 (capability ausente no servidor) degrada para vazio — comportamento
 * defensivo que os dois consumidores já tinham.
 */
export function personWaitlistQuery(personId: string | null | undefined): {
  queryKey: readonly ['person-waitlist', string | null | undefined];
  queryFn: () => Promise<WaitlistEntryWire[]>;
} {
  return {
    queryKey: ['person-waitlist', personId] as const,
    queryFn: async (): Promise<WaitlistEntryWire[]> => {
      if (personId === null || personId === undefined || personId === '') return [];
      try {
        return (await api.getWaitlist({ personId })).data;
      } catch (err) {
        if (err instanceof ApiError && err.status === 403) return [];
        throw err;
      }
    },
  };
}
